import { createContext } from 'react';

export const EnvContext = createContext();
export const EnvConsumer = EnvContext.Consumer;
